import React from 'react';
import { cn } from './cn';

const VARIANTS = {
  success: 'bg-ga-success/15 text-ga-success border-ga-success/30',
  warning: 'bg-ga-warning/15 text-ga-warning border-ga-warning/30',
  danger: 'bg-ga-danger/15 text-ga-danger border-ga-danger/30',
  info: 'bg-ga-info/15 text-ga-info border-ga-info/30',
  neutral: 'bg-ga-bg-surface-subtle text-ga-text-muted border-ga-border-subtle',
};

export default function Badge({ variant = 'neutral', className, ...props }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-ga-full border px-2.5 py-0.5 text-xs font-medium',
        VARIANTS[variant] || VARIANTS.neutral,
        className
      )}
      {...props}
    />
  );
}
